import { Deserializable } from '../../protocols/deserializable';
import { EmployerSubmissionTypeEnum } from '../../enum/shared/employer-submission-type.enum';
import { SubmissionStatusIdEnum } from '../../enum/shared/submission-status-id.enum';
import { SubmissionSubStatusIdEnum } from '../../enum/shared/submission-sub-status-id-enum';
import { SubmissionStatus, SubmissionSubStatus } from '../../shared/submission-status';
import { SubmissionStatusPill } from '../../shared/submission-status-pill';

export class EmployerMemberSubmission implements Deserializable {
  public submissionId!: number;
  public idPrefix!: string;
  public idSuffix!: string;
  public submissionTypeId!: EmployerSubmissionTypeEnum;
  public submissionTypeName!: string;
  public statusId!: SubmissionStatusIdEnum;
  public status!: SubmissionStatus;
  public subStatusId!: SubmissionSubStatusIdEnum;
  public subStatus!: SubmissionSubStatus;
  public submittedDate!: string;
  public completedDate!: string | null;
  public createdDate!: string | null;

  // Not From API
  public id!: number;
  public formattedSubmissionId!: string;
  public statusPill!: SubmissionStatusPill;

  // We do not display substatus information on EP, so user does not need to know if a submission is approved. Just Completed, Canceled etc
  public isApproved(): boolean {
    return false;
  }

  public onDeserialize(): void {
    const Deserialize = window?.injector?.Deserialize;
    this.id = this.submissionId;
    this.formattedSubmissionId = `${this.idPrefix}-${this.submissionId.toString().padStart(8, '0')}-${this.idSuffix}`;

    if (!!this.status) {
      this.status = Deserialize?.instanceOf(SubmissionStatus, this.status);
      this.statusPill = new SubmissionStatusPill(this.statusId, this.status.name, this.statusId, this.status.name);
    }
    if (!!this.subStatus) {
      this.subStatus = Deserialize?.instanceOf(SubmissionSubStatus, this.subStatus);
    }
  }
}
